import type { GetStatisticResponseDto } from '@pickthebank/api-sdk/type/response/deposit/get-statistic-response.dto';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Link from 'next-translate-routes/link';
import { type FC } from 'react';

import { Icon } from '@/components';
import { TableCell, TableRow } from '@/components/OtherDepositTable/parts';
import { useDepositsLayout } from '@/layouts/DepositsLayout/useDepositsLayout';
import { getCountryFlagURL } from '@/services/supabase';
import { cn } from '@/utils';

export interface IOtherDepositTableProps {
  className?: string;
  countries: GetStatisticResponseDto[];
  productType: 'savings account' | 'fixed term deposit';
}

export const StatisticsTable: FC<IOtherDepositTableProps> = ({
  className,
  countries,
  productType,
}) => {
  const { t } = useTranslation();

  const { getUrlWithSearchParams } = useDepositsLayout();

  return (
    <div className={className}>
      <table className="mx-auto mt-[7px] w-full">
        <thead className="table-header-group">
          <tr
            className={cn(
              'border-b-[1px] border-gray-200 py-4 child:text-left child:child:text-[13px] child:font-medium child:leading-[18px] child:tracking-[0.1px] child:text-gray-600 md:child:px-2 lg:child:px-3',
              'child:px-3',
            )}
          >
            <th className="max-w-0 pb-3 md:max-w-[unset]" />
            <th className="pb-3 !text-grey-600 md:w-[350px]">
              {t('search.country')}
            </th>
            <th className="flex max-w-[25vw] gap-1 !px-0 pb-3 !text-grey-600 md:w-[180px]">
              <p className="shrink truncate !text-grey-600">
                {t('global.highest_rate')}
              </p>
              <div>
                <Icon
                  className="size-4 grow text-transparent"
                  name="arrowDown"
                />
              </div>
            </th>
            {/* <th className="max-w-[15vw] pb-3 md:w-[180px]"> */}
            {/*  <p className="shrink truncate !text-grey-600"> */}
            {/*    {t('global.average_rate')} */}
            {/*  </p> */}
            {/* </th> */}
            <th />
          </tr>
        </thead>
        <tbody>
          {countries.map((country, index) => (
            <TableRow key={index} className="table-row py-3">
              <TableCell className="body3 py-3 pr-0 leading-[20px] text-grey-600">
                {index + 1}.
              </TableCell>
              <TableCell className="body2 flex w-[35vw] items-center gap-2 py-3 text-blue-900 md:w-[unset]">
                <Image
                  src={getCountryFlagURL(country.country)}
                  alt={country.country}
                  width={16}
                  height={12}
                  className="h-[15px] rounded-[2px]"
                />
                {t(`database.countries.${country.country}`)}
              </TableCell>

              <TableCell className="body2-bold !px-0 py-3  text-blue-900">
                {Number(country.max_gross_interest_rate).toFixed(2)}%
              </TableCell>

              {/* <TableCell className="body2 py-3"> */}
              {/*  {Number(country.avg_gross_interest_rate).toFixed(2)}% */}
              {/* </TableCell> */}
              <TableCell className="flex items-center justify-center py-3">
                <Link
                  href={getUrlWithSearchParams(
                    productType === 'savings account'
                      ? '/savings-accounts'
                      : '/fixed-deposits',
                    productType === 'savings account'
                      ? ['terms']
                      : ['cashback', 'annualFee'],
                    country.country,
                  )}
                >
                  <Icon name="shevronRight" className="size-[20px]" />
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </tbody>
      </table>
    </div>
  );
};
